import { createFileRoute, redirect } from '@tanstack/react-router'

// Root index redirects to campaigns, preserving query parameters (e.g., ?payment=success from Stripe)
export const Route = createFileRoute('/')({
  beforeLoad: ({ location }) => {
    // Preserve query string when redirecting (important for Stripe payment callbacks)
    const searchParams = location.search ? `?${new URLSearchParams(location.search as Record<string, string>).toString()}` : ''
    throw redirect({ to: `/campaigns${searchParams}` })
  },
})
